import { Form, FormikProvider, useFormik } from "formik";
import React, { useEffect, useState } from "react";
import * as yup from "yup";
import { useNavigate, useParams } from "react-router-dom";
import CustomInput from "../../../components/common/CustomInput/CustomInput";
import CustomDropdown from "../../../components/common/CustomDropdown/CustomDropdown";
import { useDispatch } from "react-redux";
import { Roles } from "../../../constansts/LocalData";
import { editUserAsync } from "../../../redux/features/editUserSlice";
import axios from "axios";
import { backdropLoadingAction } from "../../../redux/features/helperSlice";
import toast from "react-hot-toast";
import BodyHeader from "../../../components/common/CommonBodyHeader";
import { BASE_URL } from "../../../Api/services";
import { ROLES } from "../../../constansts/Roles";

export default function UserEdit() {
   const [parentId, setParentId] = useState();
   const [fetchedData, setFetchedData] = useState({
      userName: "",
      password: "",
      parentId: "",
      userType: "",
   });
   const dispatch = useDispatch();
   const navigate = useNavigate();
   const params = useParams();

   const handleUpdateUser = async (formData) => {
      dispatch(backdropLoadingAction(true));
      const data = {
         id: params.id,
         name: formData.userName,
         password: formData.password,
         model_id: 1,
         action_id: 1,
         parent_user_ids: [formData.parentId],
         mobile: formData.mobile,
      };
      dispatch(
         editUserAsync({
            data,
            done: () => {
               dispatch(backdropLoadingAction(false));
               toast.success("User updated successfully.");
               navigate("/user/user-List");
            },
            err: (error) => {
               dispatch(backdropLoadingAction(false));
               toast.error(error);
            },
         })
      );
   };

   const fetchUser = `${BASE_URL}/user/fetch/${params.id}?model_id=1&action_id=3`;

   const parentApiUrl = (slug) =>
      `${BASE_URL}/user/parent_user/${slug}?model_id=1&action_id=3`;

   const handleParentId = (_userType) => {
      console.log({ _userType }, "this is user type");
      const userType = isNaN(_userType) ? _userType?.[0]?.value : _userType;
      const slug =
         userType === ROLES.manager
            ? "manager"
            : userType === ROLES.supervisor
            ? "supervisor"
            : null;
      axios
         .get(parentApiUrl(slug), {
            headers: {
               Authorization: `Bearer ${JSON.parse(localStorage.getItem("token"))}`,
            },
         })
         .then((response) => {
            setParentId(response.data.res);
         })
         .catch((error) => {
            console.error("API Error:", error);
         });
   };

   useEffect(() => {
      if (fetchedData?.userType) {
         console.log(fetchedData?.userType, "fetchedData?.userType");
         handleParentId(fetchedData?.userType);
      }
   }, [fetchedData?.userType]);

   useEffect(() => {
      dispatch(backdropLoadingAction(true));
      const fetchData = async () => {
         try {
            const response = await axios.get(fetchUser, {
               headers: {
                  Authorization: `Bearer ${JSON.parse(localStorage.getItem("token"))}`,
               },
            });
            console.log({ response });
            setFetchedData({
               ...fetchedData,
               userName: response.data?.res?.user?.name,
               parentId: Number(response?.data?.res?.user?.parent_user_ids),
               userType: response.data?.res?.user?.role_id,
               mobile: response.data?.res?.user?.mobile,
            });
            dispatch(backdropLoadingAction(false));
         } catch (error) {
            dispatch(backdropLoadingAction(false));
         }
      };
      fetchData();
   }, [fetchUser, params.id]);

   const userAddSchema = yup.object().shape({
      userName: yup
         .string()
         .min(2, "Too Short!")
         .max(50, "Too Long!")
         .required("Required"),

      mobile: yup.string().min(9, "Too Short!").max(10, "Too Long!").required("Required"),

      userType: yup.string().required("Required"),
   });

   const formik = useFormik({
      initialValues: fetchedData,
      enableReinitialize: true,
      validationSchema: userAddSchema,
      onSubmit: handleUpdateUser,
   });

   console.log({ fetchedData });

   const { errors, touched, getFieldProps, handleSubmit, resetForm, setFieldValue } =
      formik;
   return (
      <div>
         <BodyHeader title="Edit User" />
         <div className="container">
            <div className="card card-primary ">
               <div className="card-header">
                  <h3 className="card-title text-center">Edit User</h3>
               </div>
               <FormikProvider value={formik}>
                  <Form className="needs-validation" noValidate>
                     <div className="card-body">
                        <div className="form-group">
                           <CustomInput
                              label="Enter Name"
                              name="userName"
                              id="#userName"
                              inputType="text"
                              placeholder="Enter User Name"
                              {...getFieldProps("userName")}
                              errors={errors.userName && touched.userName}
                              message={"ERROR"}
                           />
                        </div>

                        <div className="form-group">
                           <CustomInput
                              label="Enter Mobile No."
                              name="mobile"
                              id="#mobile"
                              inputType="text"
                              placeholder="Enter Mobile No."
                              {...getFieldProps("mobile")}
                              errors={errors.mobile && touched.mobile}
                           />
                        </div>

                        <div className="form-group">
                           <label className="text-bold">User Type</label>
                           <CustomDropdown
                              selected=""
                              name="userType"
                              optionData={Roles}
                              {...getFieldProps("userType")}
                              // onChange={() => {}}
                              onChange={(e) => handleParentId(e)}
                              disabled={true}
                              values={Roles.filter(
                                 (item) => item.value === getFieldProps("userType").value
                              )}
                           />
                        </div>

                        {[ROLES.supervisor, ROLES.manager].includes(
                           fetchedData?.userType
                        ) && (
                           <div className="form-group">
                              <label className="text-bold">Manager</label>
                              <CustomDropdown
                                 selected=""
                                 name="parentId"
                                 optionData={parentId?.map?.((key, index) => {
                                    return {
                                       label: key?.name,
                                       value: key?.id,
                                    };
                                 })}
                                 {...getFieldProps("parentId")}
                                 onChange={(e) => {
                                    if (e?.[0]?.value) {
                                       formik.setFieldValue("parentId", e?.[0]?.value);
                                    }
                                 }}
                              />
                           </div>
                        )}

                        <div className="form-group">
                           <CustomInput
                              label="Password"
                              name="password"
                              id="#password"
                              inputType="text"
                              placeholder="********"
                              {...getFieldProps("password")}
                              errors={errors.password && touched.password}
                           />
                        </div>

                        <div className="form-group">
                           <CustomInput
                              label="Confirm Password"
                              name="c_password"
                              id="#c_password"
                              inputType="text"
                              placeholder="********"
                              {...getFieldProps("c_password")}
                              errors={errors.c_password && touched.c_password}
                           />
                        </div>
                     </div>
                     <div className="card-footer d-flex justify-content-center">
                        <button
                           type="submit"
                           className="btn btn-primary"
                           onClick={handleSubmit}
                        >
                           Update User
                        </button>
                     </div>
                  </Form>
               </FormikProvider>
            </div>
         </div>
      </div>
   );
}
